import React from "react";

interface PublishResultCardProps {
  /** Chips and actions for the grey header strip. */
  header: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Shell shared by the publish success and failure cards. The two render one
 * above the other in the same dialog across consecutive steps, so the frame
 * around them has to be one thing rather than two that drift apart.
 */
export default function PublishResultCard(props: PublishResultCardProps) {
  const { header, children } = { ...props };

  return (
    <div className="w-full min-w-0 max-w-full overflow-hidden rounded-[8px] border border-solid border-creator-border bg-creator-surface">
      <div className="flex flex-wrap items-center gap-[8px] border-0 border-b-[1px] border-solid border-creator-border bg-[var(--pi-surface-hover)] py-[10px] pl-[16px] pr-[12px]">
        {header}
      </div>
      {children}
    </div>
  );
}
